import TaskPrompt from './TaskPrompt'
import enhance from './TaskPrompt.enhancer'

export default enhance(TaskPrompt)



// WEBPACK FOOTER //
// ./src/components/TaskPrompt/index.js